@if (service) {
  <div class="flex text-navy-90 font-bold text-base">
    {{ buildTranslationKey('slackNotifications') | translate }}
  </div>
  <div class="text-navy-70 text-base">
    {{ buildTranslationKey('slackNotificationsDescription') | translate }}
  </div>

  @if (isInstalled) {
    <div
      class="flex items-center gap-x-3 cursor-pointer w-min"
      role="button"
      (click)="updateSlackEnabledFlag(!slackEnabled)"
    >
      <app-toggle [ngModel]="slackEnabled" (ngModelChange)="updateSlackEnabledFlag($event)"></app-toggle>
      <span class="text-navy-70 text-base ellipsis">{{ buildTranslationKey('enableSlack') | translate }}</span>
    </div>
  } @else {
    <div class="flex flex-row items-center gap-4">
      <app-new-button
        [type]="'primary'"
        [size]="'responsive'"
        [svgIconPath]="'plugins/slack'"
        (click)="openPluginPage()"
      >
        {{ buildTranslationKey('connectSlackBtn') | translate }}
      </app-new-button>

      <app-new-button [svgIconPath]="'bulb'" [type]="'secondary'" [size]="'medium'" (click)="openHowToConnectPage()">
        {{ buildTranslationKey('howToConnectBtn') | translate }}
      </app-new-button>
    </div>
  }

  @if (slackEnabled && hasMultipleInstances) {
    <div class="flex flex-col gap-1">
      <span class="font-bold text text-sm">{{ buildTranslationKey('slackAccount') | translate }}</span>
      <app-dropdown-control
        class="w-50"
        [data]="installedInstances"
        [displayValueSelector]="displayAccountValueSelector"
        [searchEnabled]="true"
        [formControl]="instanceDropdownControl"
        [placeholderTranslationKey]="buildTranslationKey('selectAccount') | translate"
      ></app-dropdown-control>
    </div>
  }

  @if (slackEnabled) {
    <div class="flex flex-col gap-2">
      <span class="font-bold text text-sm">{{ buildTranslationKey('slackChannels') | translate }}</span>
      <app-slack-channels-users-dropdown
        [channelsUsersData]="channelsUsersData"
        [selectedDataIds]="selectedChannelsUsers"
        [selectedInstanceId]="instanceDropdownControl?.value?.service_instance_id"
      ></app-slack-channels-users-dropdown>
    </div>
  }
}
